/* eslint import/no-webpack-loader-syntax: 0 */
import React, { useContext, useEffect } from 'react';

import RandomDue from './RandomDue';
import MobileViewContext from '../../mobile_view_context';
import BotListWidgets from '../BotListWidgets';
import PopupLink from '../PopupLink';
import DonateButton from './DonateButton';
import { SUPPORT_SERVER, INVITE_URL, setTitle } from '../../config';

import dueLogoImg from '../../images/due_logo.webp';
import dueLogoFallbackImg from '../../images/due_logo.png'

import arrowsImg from '../../images/arrows.svg';
import ziggleZaggleWiggleWaggleImg from '../../images/ziggle_zaggle_wiggle_waggle.svg';
import doritoImg from '../../images/dorito.svg';

import battlesCardImg from '../../images/Box_1_Battles.png';
import questsCardImg from '../../images/Box_2_Quests.png';
import customisationCardImg from '../../images/Box_3_Customisation.png';
import leaderboardCardImg from '../../images/Box_4_Leaderboards.png';

// const BattlesCard = lazy(() => import('./BattlesCard'));
// const CustomisationCard = lazy(() => import('./CustomisationCard'));
// const QuestsCard = lazy(() => import('./QuestsCard'));
// const LeaderboardCard = lazy(() => import('./LeaderboardCard'));

const Home = () => {
  const mobile = useContext(MobileViewContext);

  useEffect(() => {
    setTitle("Questing and fun Discord bot!");
  }, []);

  return (
    <div id="due-landing">
      {!mobile && <RandomDue />}
      <div id="due-landing__hero">
        <div id="due-landing__dorito">
          <img draggable={false} alt="" id="due-landing__dorito__dorito" src={doritoImg} />
          <div style={{ position: "absolute", top: 10, width: "100%" }}>
            <picture>
              <source type='image/webp' srcSet={dueLogoImg} />
              <img draggable={false} alt="DueUtil Logo!" id="due-landing__logo" src={dueLogoFallbackImg}
                style={{ width: mobile ? 'calc(40px + 7.5vw)' : 'auto' }} />
            </picture>
            <h1>DUeutil</h1>
            <h2>Questing & Fun Discord Bot</h2>
            <img draggable={false} alt="" style={{ width: "14%" }} src={ziggleZaggleWiggleWaggleImg} />
            <p id="due-landing__dorito__desc">
              DueUtil adds the ability to create quests to fight, and weapons to use!
              Battle other players & quests to gain EXP,
              stats and cash rewards!
            </p>
          </div>
          <br />
          <div id="due-landing__dorito__arrows">
            <div className="arrow-side-content">
              <PopupLink href={SUPPORT_SERVER}>
                <button className="due-landing__dorito-btn orange-btn">Join our Discord</button>
              </PopupLink>
            </div>
            <img draggable={false} alt="" id="due-landing__dorito__arrows__arrow" src={arrowsImg} />
            <div className="arrow-side-content">
              <PopupLink href={INVITE_URL}>
                <button className="due-landing__dorito-btn white-btn">Invite DueUtil</button>
              </PopupLink>
            </div>
          </div>
          <DonateButton />
        </div>
      </div>
      {!mobile && <RandomDue />}
      <div className="flex-break"></div>
      <h2 className="due-landing__heading">Features</h2>
      <div id="due-landing__features">
        {/* <Suspense fallback={<div/>}>
          <BattlesCard/>
          <QuestsCard/>
          <CustomisationCard/>
          <LeaderboardCard/>
        </Suspense> */}
        <img draggable={false}
          alt="Battles! Battle with your friends, see who's the strongest, and claim the title of Top Dog!"
          className="due-landing__feature" src={battlesCardImg} />
        <img draggable={false}
          alt="Quests! Slay evil quests and reap the epic rewards!"
          className="due-landing__feature" src={questsCardImg} />
        <div style={{ width: "100%" }}></div>
        <img draggable={false} alt="Customisations! Customize your profile with awesome themes, banners, and backgrounds!"
          className="due-landing__feature" src={customisationCardImg} />
        <img draggable={false}
          alt="Leaderboards! Climb the leaderboard, and become the ultimate player!"
          className="due-landing__feature" src={leaderboardCardImg} />
      </div>
      <BotListWidgets />
    </div >)
};

export default Home;
